export const RadioGroup: React.FC<{
  options: { label: string; value: string }[];
  value: string; onChange: (v: string) => void; name: string;
}> = ({ options, value, onChange, name }) => (
  <div className="flex flex-wrap gap-4">
    {options.map((opt) => (
      <label key={opt.value} className="flex items-center gap-2 cursor-pointer select-none text-sm text-gray-700 dark:text-gray-300">
        <input
          type="radio" name={name} value={opt.value}
          checked={value === opt.value} onChange={() => onChange(opt.value)}
          className="accent-indigo-600 dark:accent-indigo-500 w-4 h-4"
        />
        {opt.label}
      </label>
    ))}
  </div>
);
